export const DEV_MODE = process.env.NODE_ENV === "development";
export const ONLINE_MODE = JSON.parse(process.env.REACT_APP_ONLINE_MODE);
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const PBI_URL = process.env.REACT_APP_PBI_URL;
export const PBI_TOKEN_URL = process.env.REACT_APP_PBI_TOKEN_URL;

/* Password recovery lives on the new backend, which is a different service from
 * the monolith this app talks to for everything else — so it gets its own base
 * URL. Falls back to the main backend when unset, which is what a build wants
 * once the monolith itself serves the recovery endpoints.
 *
 * Note the two backends have separate user stores: a reset issued here only
 * affects the account in whichever system this URL points at.
 *
 * A base URL pasted with a trailing slash would otherwise produce a double
 * slash in the request path. */
const stripTrailingSlash = url => (url && url.endsWith("/") ? url.slice(0, -1) : url);

export const RECOVERY_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_RECOVERY_BASE_URL || BACKEND_BASE_URL
);

export const MODES = {
  LUBRICATION: "lubrication",
  INSTRUMENTS: "instruments",
};

export const MODE = MODES.LUBRICATION;

export const SOFT_VERSION = [
  ["TGD", "3.4.4.3", "TGD SOFT"],
  ["STI", "1.3.1", "STI SENSORING"],
];
